import React from 'react'
import {UiSlot} from '@api/components'
import {ApiPopup} from '@api/components/api-popup'
import {ColumnsSortPopup} from '@components/columns/columns-sort/columns-sort-popup'
import {PopupHost} from '@components/common/base/popup/popup-host'
import {NewsPopup} from '@components/news/news-popup'
import {ProjectParticipants} from '@components/project-participants/project-participants'
import {RegistrationFinishPopup} from '@components/registration-finish/registration-finish-popup'
import {RepeatEdit} from '@components/repeat/repeat-edit'
import {ScreencastControls} from '@components/screencast'
import {TimelineAutoPlanningPopup} from '@components/timeline-new/timeline-auto-planning-popup'
import {WorkflowPopup} from '@components/workflow/workflow-popup'
import {ApiDialog} from '../../api/components/api-dialog'

export const PopupContainer = () => {
  return (
    <>
      <UiSlot name="overlay-container" />
      <RepeatEdit />
      <ApiPopup />
      <ApiDialog />
      <ProjectParticipants />
      <NewsPopup />
      <RegistrationFinishPopup />
      <WorkflowPopup />
      <ColumnsSortPopup />
      <TimelineAutoPlanningPopup />
      <ScreencastControls />
      <PopupHost />
      <div id="description-fullscreen"></div>
    </>
  )
}
